var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tab',{attrs:{"title":_vm.$t('content.label')}},[_c('b-form-group',[_c('c-rich-text-input',{attrs:{"labels":{
        urlPlaceholder: _vm.$t('content.urlPlaceholder'),
        ok: _vm.$t('content.ok'),
        openLinkInNewTab: _vm.$t('content.openLinkInNewTab'),
      }},model:{value:(_vm.options.body),callback:function ($$v) {_vm.$set(_vm.options, "body", $$v)},expression:"options.body"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }